/**
 * Central route paths — use these in navigate/Link to keep URLs consistent.
 * Public purchase flow uses short, readable paths instead of legacy technical ones.
 */
export const paths = {
  home: '/',
  signIn: '/signin',
  signUp: '/signup',

  /** Standard raffle — pick ticket numbers */
  buyTickets: rifaId => `/comprar/${rifaId}`,
  /** Board raffle — pick squares */
  buyBoard: rifaId => `/tablero/${rifaId}`,
  /** Buyer details step */
  reserve: '/reserva',
  reserveBoard: '/reserva-tablero',
  /** Payment / checkout step */
  checkout: reservaId => `/pago/${reservaId}`,

  admin: {
    root: '/admin',
    dashboard: '/admin',
    analytics: '/admin/analytics',
    rifas: '/admin/rifas',
    addRifa: '/admin/rifas/nueva',
    editRifa: id => `/admin/rifas/${id}/editar`,
    /** Ticket PDF block layout editor */
    rifaTicketDesign: id => `/admin/rifas/${id}/boleto`,
    rifa: id => `/admin/rifas/${id}`,
    reservas: '/admin/reservas',
    confirmarPago: id => `/admin/reservas/${id}/confirmar`,
    tickets: '/admin/tickets',
    users: '/admin/usuarios',
    newUser: '/admin/usuarios/nuevo',
    editUser: id => `/admin/usuarios/${id}/editar`,
    viewUser: id => `/admin/usuarios/${id}`,
    redeem: '/admin/validar',
    newsletter: '/admin/newsletter',
    config: '/admin/configuracion',
    /** Live raffle draw (presentation / screen-recording mode) */
    liveDraw: '/admin/sorteo-en-vivo',
    liveDrawFor: (rifaId, sorteoId) =>
      `/admin/sorteo-en-vivo?rifa=${encodeURIComponent(rifaId || '')}` +
      (sorteoId ? `&sorteo=${encodeURIComponent(sorteoId)}` : ''),
  },
};

/** True when the current path is any admin area (new or legacy URLs). */
export function isAdminPath(pathname = '') {
  return pathname.startsWith('/admin') || pathname.includes('AdminScreen');
}

/** Human-readable payment method title (DB `method` slug → label). */
export function formatPaymentMethodTitle(method) {
  const raw = String(method?.method || method?.name || '').trim();
  if (!raw) return 'Método de pago';
  const key = raw.toLowerCase().replace(/[\s_-]+/g, '');
  const labels = {
    mercadopago: 'Mercado Pago',
    mercadopagocuotas: 'Mercado Pago — Cuotas',
    transferencia: 'Transferencia bancaria',
    deposito: 'Depósito bancario',
  };
  if (labels[key]) return labels[key];
  if (/^[a-z0-9]+$/.test(raw) && !raw.includes(' ')) {
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  }
  return raw;
}

/** Short description for homepage cards. */
export function paymentMethodDescription(method) {
  return (method?.homeDescription || method?.details || '').trim();
}
